<template>
  <div>
    <div>
      <div class="font-weight-bold mb-1 mt-5">
        Languages & Skills
      </div>
      <div v-for="(step, index) in allSteps" :key="index">
        <component
          :submitButtonTitle="submitButtonTitle"
          :is="step"
          v-if="
            shouldStepViewBeShown(index) || ifStepHasAlreadyBeenCompleted(index)
          "
          v-show="shouldStepViewBeShown(index)"
          @nextStep="stepForward"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Languages from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Languages/Languages";
import Skills from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Skills";
import { isPermissioned } from "@/utils/permissions";
import { size } from "lodash";
import { PERMISSIONS } from "@/constants/workers";

const { LANGUAGES_AND_SKILLS } = PERMISSIONS;

export default {
  components: {
    Languages,
    Skills
  },
  props: {
    submitButtonTitle: String
  },
  created() {
    this.emitProgressValue({ step: this.steps.current });
  },
  data() {
    return {
      steps: {
        current: 1,
        saved: 0
      },
      allSteps: [
        this.showStep(LANGUAGES_AND_SKILLS.languages) && Languages,
        this.showStep(LANGUAGES_AND_SKILLS.skills) && Skills
      ].filter(Boolean)
    };
  },
  computed: {
    progressValue() {
      return (this.steps.current / this.totalSteps) * 100;
    },
    totalSteps() {
      return size(this.allSteps);
    },
    // needed value for parent form component
    showBackButton() {
      return this.steps.current > 1;
    }
  },
  methods: {
    emitProgressValue({ step }) {
      this.$emit("onStepChanged", {
        progressValue: (step / this.totalSteps) * 100
      });
    },
    onClose() {
      this.$emit("close");
    },
    stepForward() {
      if (
        this.steps.saved < this.totalSteps &&
        this.steps.current > this.steps.saved
      ) {
        this.steps.saved += 1;
      }
      this.emitProgressValue({ step: this.steps.current + 1 });
      if (this.steps.current < this.totalSteps) this.steps.current += 1;
      else {
        this.onClose();
      }
    },
    stepBack() {
      this.emitProgressValue({ step: this.steps.current - 1 });
      if (this.steps.current > 1) {
        this.steps.current--;
      }
    },
    shouldStepViewBeShown(index) {
      const viewStep = index + 1;
      return viewStep <= this.totalSteps && this.steps.current === viewStep;
    },
    ifStepHasAlreadyBeenCompleted(index) {
      const viewStep = index + 1;
      return viewStep <= this.steps.saved;
    },
    showStep(permission) {
      return isPermissioned(`workers.edit.${permission}`);
    }
  }
};
</script>

<style lang="scss"></style>
